export default __webpack_public_path__ + "static/media/silang.33285942.jpg";